import axios from '../request'

// 语音控制相关接口
export default {
  getMqttOptions() {
    return axios({ name: '获取mqtt配置信息', method: 'post', url: '/serve-connect/api/v1/product/credential' })
  }
}
